import React from 'react'
import { DataCylinder } from './DataCylinder'
import { IsometricFactory } from './IsometricFactory'
import { ScrollReveal } from './ScrollReveal'

interface ItsDifferentSectionProps {
  isDark?: boolean
}

export const ItsDifferentSection: React.FC<ItsDifferentSectionProps> = ({ isDark = true }) => {
  return (
    <section
      id='economics'
      className='py-24 px-6 md:px-12 bg-zinc-50 dark:bg-zinc-950 transition-colors duration-500 overflow-hidden'
    >
      <div className='max-w-7xl mx-auto'>
        <div className='flex flex-col lg:flex-row justify-between items-center gap-12'>
          <div className='lg:w-1/2'>
            <ScrollReveal>
              <span className='mono text-[#0052FF] font-bold tracking-widest uppercase text-[18px]'>
                [ IT'S DIFFERENT ]
              </span>
              <h2 className='text-4xl md:text-5xl font-black mt-4 text-zinc-900 dark:text-white uppercase tracking-tighter'>
                Not like other agents
              </h2>
              <div className='mt-8'>
                <IsometricFactory isDark={isDark} />
              </div>
            </ScrollReveal>
          </div>

          <div className='hidden lg:flex lg:w-1/2 justify-center'>
            <DataCylinder isDark={isDark} />
          </div>
        </div>
      </div>
    </section>
  )
}
